import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { InputRange } from '../../ui-kit/InputRange/InputRange.js';
const MIN_CREDIT_AMOUNT = 1000;
const MAX_CREDIT_AMOUNT = 1000000000;
const ITEMS_CREDIT_AMOUNT = ['От 1 000 ₽', 'До 1 000 000 000 ₽'];
export const AmountField = JSX(({ field }) => (_jsx(InputRange, { title: "\u0421\u0443\u043C\u043C\u0430, \u20BD", items: ITEMS_CREDIT_AMOUNT, min: MIN_CREDIT_AMOUNT, max: MAX_CREDIT_AMOUNT, ...field('amount') })));
//# sourceMappingURL=AmountField.js.map